import { render, staticRenderFns } from "./ProductButtongroup.vue?vue&type=template&id=89afd52e"
import script from "./ProductButtongroup.vue?vue&type=script&lang=js"
export * from "./ProductButtongroup.vue?vue&type=script&lang=js"
import style0 from "./ProductButtongroup.vue?vue&type=style&index=0&id=89afd52e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports